import { APIClient, JavaAPIClient } from '../lib/apiHelper'
const {post, get, put} = new APIClient()
const { get: _get, put: _put } = new JavaAPIClient();

export default {
    
    alarm: alarm => _get('/alarm?companyId=' + alarm),
    alarmModify: alarm => put('/alarm', alarm),
    alarmSetting: alarm => _get('/alarm/setting?userId=' + alarm),
    alarmSettingModify: alarm => _put('/alarm/setting', alarm),
    alarmSettingLangModify: lang => _put('/alarm/setting/lang?lang=' + lang),
    alarmRead: alarm => _put('/alarm/read', alarm),
    alarmReadAll : userCompanyData => _put('/alarm/read/all',userCompanyData),

}